/** Persisted dashboard (role portal) appearance — shared across owner, tenant, realtor, professional. */
export const DASHBOARD_THEME_STORAGE_KEY = 'tenantDispatch-dashboard-theme';

/** Same-tab listeners (storage event only fires across tabs). */
export const DASHBOARD_THEME_EVENT = 'tenantdispatch-dashboard-theme';

/** @param {'light' | 'dark'} mode */
export function emitDashboardThemeChange(mode) {
  try {
    window.dispatchEvent(new CustomEvent(DASHBOARD_THEME_EVENT, { detail: { mode } }));
  } catch {
    /* ignore */
  }
}

/** @returns {'light' | 'dark'} */
export function getStoredDashboardTheme() {
  try {
    const v = localStorage.getItem(DASHBOARD_THEME_STORAGE_KEY);
    if (v === 'dark' || v === 'light') return v;
  } catch {
    /* ignore */
  }
  return 'light';
}

/** @param {'light' | 'dark'} mode */
export function setStoredDashboardTheme(mode) {
  try {
    localStorage.setItem(DASHBOARD_THEME_STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}

/** @param {'light' | 'dark'} mode */
export function applyDashboardThemeToDocument(mode) {
  const root = document.documentElement;
  if (mode === 'dark') root.classList.add('theme-dark');
  else root.classList.remove('theme-dark');
}
